import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import xeRebook from 'actions/booking/xeRebook.action';
import ICO_CLOSE from 'assets/images/btn-close.svg';
import { fromPathnameToIsWeek } from 'bl/pathname.bl';
import DatePickerInput from 'components/form/DatePickerInput.component';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatYearToDayCompact, formatYearToDayStandard } from 'utils/date/format.util';
import { nowAsMoment } from 'utils/date/now.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';
import { deepFreeze } from 'utils/values/constant.util';

import TextField from 'booking/components/common/TextField';
import { setCurrentDay, setView } from 'scheduler/actions';
import { REBOOK_TIME } from 'scheduler/components/common/RebookAppointmentDialog.component';

const L = logger('RebookAppointment');

class RebookAppointment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: nowAsMoment(),
      showDatePicker: true,
    };
  }

  setRebookDay = (date) => {
    const { showRebook, history, salonId, oldAppointment, from, fetchProceduresBySalon, fetchEventsBySalon, rebook } =
      this.props;

    this.setState({ selectedDate: moment(date) });

    if (nowAsMoment().isSame(moment(date), 'day')) return;

    const ele = document.querySelector('.card-modal-wraper .close');
    if (ele) ele.click();

    if (from === REBOOK_TIME.before) deepFreeze(oldAppointment);

    const oldDate = moment(oldAppointment?.procedures?.[0]?.start_time).toISOString();
    const newDate = formatYearToDayStandard(date);

    rebook(Object.assign({}, oldAppointment), from, newDate, oldDate);

    let url = `/salon/${salonId}/day/${formatYearToDayCompact(date)}/appointment/new/services`;

    const isWeek = fromPathnameToIsWeek(history.location.pathname);

    if (isWeek) {
      const stylistId = parseInt(history.location.pathname.split('/').pop(), 10);
      const bgn = moment(newDate).startOf('week');
      const end = moment(newDate).endOf('week');

      L.unignore('setRebookDay()', 'fetchProceduresBySalon:', fetchProceduresBySalon(salonId, bgn, end, stylistId));
      L.unignore('setRebookDay()', 'fetchEventsBySalon:', fetchEventsBySalon(salonId, bgn, end, stylistId));

      if (isWeek && stylistId) {
        url = `/salon/${salonId}/week/${moment(newDate).format('W[W]YYYY')}/${stylistId}/appointment/new/services`;
      }
    } else {
      L.unignore('setRebookDay()', 'fetchProceduresBySalon:', fetchProceduresBySalon(salonId, newDate));
      L.unignore('setRebookDay()', 'fetchEventsBySalon:', fetchEventsBySalon(salonId, newDate));
    }

    showRebook(false);
    history.push(url);
  };

  render() {
    const { selectedDate, showDatePicker } = this.state;
    const pathname = this.props.history.location.pathname;

    const stylistId = pathname.toLowerCase().indexOf('week/') > 0 ? parseInt(pathname.split('/').pop(), 10) : void 1;

    const handleDateChange = (date) => {
      const startOfDay = date.startOf('day');

      this.props.setCurrentDay(startOfDay);
      this.props.setView(this.props.dayView, startOfDay, stylistId);
      this.setRebookDay(startOfDay);
    };

    const handleWeekChange = (date) => {
      const startOfDay = date.startOf('day');

      this.props.setCurrentDay(startOfDay);
      this.props.setView(this.props.dayView, startOfDay, stylistId);
      this.setRebookDay(startOfDay);
    };

    const handleIconClick = () => this.props.showRebook(false);

    L.debug('render()', { showDatePicker, selectedDate, stylistId, pathname });

    return (
      <div data-bem="RebookAppointment" className="rebook-dpicker-input from-appointment-card">
        {showDatePicker && (
          <>
            <div role="button" className="close-style" tabIndex={0} onClick={handleIconClick}>
              <img src={ICO_CLOSE} alt="" />
            </div>
            <div className="picker-overlay" style={{ zIndex: '-1' }} />
            <TextField labelName="Select a date or skip forward for weeks" htmlFor="rebookDayPicker">
              <div className="co-date-picker" id="rebookDayPicker">
                <DatePickerInput
                  tag="RebookAppointment__common-date-picker"
                  component={DatePickerInput.CommonDatePicker}
                  inline
                  selected={selectedDate}
                  locale="en-GB"
                  onOutsideClick={alwaysNoop}
                  onChange={handleDateChange}
                />
                <DatePickerInput
                  tag="RebookAppointment__week-component"
                  component={DatePickerInput.WeeksComponent}
                  onChangeDate={handleWeekChange}
                  selectedDate={moment(selectedDate)}
                />
              </div>
            </TextField>
          </>
        )}
      </div>
    );
  }
}

const RebookAppointmentHoc = withRouter(
  connect(
    (state) => ({
      salonId: state.currentSalon.id,
      dayView: state.scheduler.dayView,
    }),
    mapActionsToDispatchToProps({
      setCurrentDay,
      rebook: xeRebook,
      setView,
    }),
  )(RebookAppointment),
);

export default RebookAppointmentHoc;
